// extracted by mini-css-extract-plugin
module.exports = {"commentTextArea":"theme_commentTextArea__3VmfJ"};